import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Page from 'flarum/common/components/Page';

import Session from 'flarum/common/Session';

import SettingsPage from 'flarum/forum/components/SettingsPage';

import LogInButton from 'flarum/forum/components/LogInButton';
import Button from 'flarum/common/components/Button';

import TermsConditionsModal from './components/TermsConditionsModal';
import VerfiyEmailModal from './components/VerfiyEmailModal';

app.initializers.add('thedesktop/ui', (app) => {
  /* extend(HeaderSecondary.prototype, 'items', function (items) {
    items.remove('signUp');
    items.remove('logIn');

    if (!app.session.user) {
      items.add(
        'login-auth0',
        <LogInButton className="Button FoFLogInButton LogInButton" path={`/auth/auth0`}>
          Login
        </LogInButton>
      );
    }
  }); */

  // Remove Flarum login fields
  /* extend(LogInModal.prototype, 'fields', function (fields) {
    fields.remove('identification');
    fields.remove('password');
    fields.remove('remember');
    fields.remove('submit');
  }); */

  // Add elements to modal
  extend(LogInModal.prototype, 'content', function (content) {
    // Copy Auth0 login button so we can add it in the end
    let firstElem = content[0];
    let footerElem = content[1];

    // Remove Auth0 login button, to add in the end
    content.splice(0, 1);
    content.splice(0, 1);

    // Add elements
    content.push(
      m(
        'div.px-2',
        m(
          'div.pb-2',
          { style: 'text-align: center;' },
          m('img', { src: 'https://www.childcarecentredesktop.com.au/wp-content/uploads/2016/01/ccd-logo-dark.png' })
        ),
        m('p.px-2', m.trust('"Tell me and I forget, teach me and I remember, involve me and I learn"<br><em>- Benjamin Franklin</em>'))
      )
    );

    // Add Auth0 login button back
    content.push(firstElem);
    content.push(footerElem);
  });

  // Redirect user to Guidelines page or T&Cs page, checks for cookie
  extend(Page.prototype, 'oninit', function () {
    const User = app.session.user;
    const baseUrl = app.forum.attribute('baseUrl');

    var url = window.location.href;
    let searchParams = new URLSearchParams(window.location.search);
    if (url.indexOf('?error=') != -1) {
      if (searchParams.get('error') == 'access_denied') {
        if (
          url.indexOf('error_description=') != -1 &&
          url.indexOf('uid=') != -1 &&
          url.indexOf('reason') != -1 &&
          searchParams.get('reason') == 'unverified'
        ) {
          setTimeout(() => {
            app.modal.show(VerfiyEmailModal);
          }, 100);
        }
      }
    }

    if (
      url.indexOf('supportSignUp') != -1 &&
      url.indexOf('success') != -1 &&
      url.indexOf('code') != -1 &&
      searchParams.get('success') == 'true' &&
      searchParams.get('code') == 'success'
    ) {
      setTimeout(() => {
        extend(LogInModal.prototype, 'content', function (content) {
          // Add elements
          $('.Modal-body').prepend('<div class="px-2 pb-2" style="text-align: center; color: #02b4cf;">Your email address has been verified.</div>');
        });

        app.modal.show(LogInModal);
      }, 100);
    }

    if (User) {
      function createCookie(name, value, days) {
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = '; expires=' + date.toGMTString();
        } else var expires = '';
        document.cookie = name + '=' + value + expires + '; path=/';
      }

      function readCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      // Prompt to accept T&C upon login
      if (!readCookie('loggedIn') && window.location.pathname != '/p/1-terms-of-use') {
        setTimeout(() => {
          app.modal.show(TermsConditionsModal);
        }, 100);
      } else {
        function redirect() {
          var thecookie = readCookie('doRedirect');
          if (!thecookie) {
            location.href = baseUrl + '/p/1-terms-of-use';
          }
        }

        window.onload = function () {
          redirect();
          createCookie('doRedirect', 'true', '9999');
        };
      }
    }
  });

  // Clear cookie on logout
  extend(Session.prototype, 'logout', function () {
    var date = new Date();
    date.setTime(date.getTime() - 60 * 60 * 24 * 365 * 1000);
    var expires = '; expires=' + date.toGMTString();
    document.cookie = 'loggedIn= ; ' + expires + '; path=/';
  });

  // Remove Account Items from Settings page
  extend(SettingsPage.prototype, 'accountItems', function (items) {
    if (this.user !== app.session.user) {
      return;
    }
    items.remove('linkedAccounts');
    items.remove('changeEmail');
    // items.remove('changePassword');
    /* items.replace(
      'changePassword',
      <Button
        className="Button"
        id="btn-change-password"
        onclick={(e) => {
          e.preventDefault();
          sendPasswordResetLink();
        }}
      >
        {app.translator.trans('core.forum.settings.change_password_button')}
      </Button>
    ); */
  });

  function sendPasswordResetLink() {
    app.alerts.clear();

    let btn = $('#btn-change-password');
    btn.prop('disabled', true);
    $('.change-password-message').remove();

    app
      .request({
        method: 'POST',
        url: '/api/ui/change-password',
      })
      .then(function (response) {
        if (response.success) {
          app.alerts.show({ type: 'success' }, 'We sent you an email with instructions on how to reset your password.');
          btn.parent().append('<p class="change-password-message">We sent you an email with instructions on how to reset your password.</p>');
        } else {
          app.alerts.show({ type: 'error' }, 'Something went wrong, please try again.');
          btn.parent().append('<p class="change-password-message">Something went wrong, please try again.</p>');
        }
      })
      .catch(function (e) {});

    setTimeout(() => {
      $('#btn-change-password').prop('disabled', false);
      $('.change-password-message').remove();
    }, 30 * 1000); // Enable after 30 seconds
  }

  // Remove Account Section from Settings page
  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    // items.remove('account');
  });

  extend(SignUpModal.prototype, 'content', function (content) {
    $('.Form--centered')
      .find('p:first')
      .text('You are one step away from joining our Forum Community.  Enter your details below... see you on the other side!!');

    // content[0].children[1].children[0].children[0].text =
    //   'You are one step away from joining our Forum Community.  Enter your details below... see you on the other side!!';
  });
});
